import {React,useEffect} from "react";
import { Grid } from "@mui/material";
import Logo from "../assets/images/icons/pm-logo.svg";
import { StyledBadge } from "../assets/js/Theme";
import { injectIntl } from "react-intl";
import { HOLO_COMPANY_ID } from "../resources/Constants";

function Header(props) {
  const {currentUser } = props;
  const { REACT_APP_S3_URL } = process.env
  const companyLogo = currentUser?.company_logo_lite_theme ? currentUser.company_logo_lite_theme : currentUser?.company_logo ? currentUser.company_logo : ""
  const logoUrl = companyLogo ? `${REACT_APP_S3_URL}img/client/logo/${companyLogo}` : Logo
  const productLogoUrl = currentUser?.company_id === HOLO_COMPANY_ID ? `${REACT_APP_S3_URL}img/valcheck-lite-theme-logo.png` : `${REACT_APP_S3_URL}img/valud-logo.png`
  const logoAppendDetach = () => {
    var wWidth = window.innerWidth;
    var footerElement = document.querySelector('footer');
    var headerText = document.querySelector('.header-text');
    var headerWrapper = document.querySelector('.header--wrapper');
    var companyLogo = document.querySelector('.company-logo');
    var footerLogo = document.querySelector('.footer-logo');
    if(wWidth <=899){
      var headerTextWrap = document.querySelector(".header--wrapper").closest(".header-text");
        if(headerTextWrap != null){
          headerWrapper.removeChild(headerText);
        }
        footerElement.insertBefore(headerText,footerLogo);
      }
      else{
        var footerTextWrap = document.querySelector("footer").closest(".header-text");
        if(footerTextWrap != null){
          footerElement.removeChild(headerText);
        }
        headerWrapper.insertBefore(headerText,companyLogo);
      }
    }
  window.addEventListener('resize',logoAppendDetach);
  //window.addEventListener('load',logoAppendDetach);
  useEffect(() => {
    logoAppendDetach();
  });
  return (
    <Grid container className="header--wrapper">
      <Grid item xs={12} md={6} className="header-text">
        <StyledBadge overlap="rectangular" className="beta-logo"
          // badgeContent={intl.formatMessage({id:"LOGO.BETA"})}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          color="secondary"
        >
          {/* <StyleHeading color="primary" variant="h3">
            {currentUser.company_id === HOLO_COMPANY_ID ? intl.formatMessage({ id: "HEADER.VALCHECK" }) : intl.formatMessage({ id: "HEADER.VALU_D" })}
          </StyleHeading> */}
        <img src={productLogoUrl} height="75" alt="Property Monitor" />
        </StyledBadge>
      </Grid>
      <Grid item xs={12} md={6} align="right" className="company-logo">
        <div className="company-logo-inner">
          <img src={logoUrl} alt={currentUser?.company_name || "Property Monitor"} />
        </div>
      </Grid>
    </Grid>
  );
}

export default injectIntl(Header);
